import { svgMarkerConfig } from "./SvgMarkerConfig.js";
import svgClusterCircle from '../assets/marker_cluster.svg?raw';
import svgMarkerSegment from '../assets/marker_segment.svg?raw';
import svgFurtherArchives from '../assets/further_archives.svg?raw';

export class MarkerFactory {
    static createAdvancedMarker(options) {
        return new google.maps.marker.AdvancedMarkerElement(options);
    }

    static setRotatedState(marker){
        if(!marker?.content || !marker.content.dataset) { return; }
        this._setSvgRotatedState(marker);
    }

    static GetClusterMarkerContent(documentCount) {
        const documentClusterMarkerContentContainer = document.createElement("div");
        documentClusterMarkerContentContainer.className = "documentClusterMarker";

        const clusterLabel = document.createElement("div");
        clusterLabel.className = "label documentClusterMarkerMouse";
        clusterLabel.textContent = documentCount;
        documentClusterMarkerContentContainer.appendChild(clusterLabel);

        return documentClusterMarkerContentContainer;
    }

    static GetDocumentMarkerContent() {
        const documentMarkerContentContainer = document.createElement("div");
        documentMarkerContentContainer.className = "documentMarker";

        return documentMarkerContentContainer;
    }


    /***
     Marker creation related methods
     ***/

    static createArchiveMarker(map, archiveName, latitude, longitude){
        return this._createSvgArchiveMarker(map, archiveName, latitude, longitude);
    }

    static _createSvgArchiveMarker(map, archiveName, latitude, longitude) {
        const div = document.createElement('div');
        div.className = 'svgMarker svgMarker--archive';
        div.innerHTML = svgFurtherArchives;
        div.dataset.markerRenderer = 'svg';

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: new google.maps.LatLng(latitude, longitude),
            title: `Topothek ${archiveName}`,
            content: div,
            gmpClickable: true
        });
        return marker;
    }

    static createDocumentClusterMarker(map, position, documentCount) {
        const documentClusterMarker = this._createSvgClusterMarker(map, position);

        const clusterLabelContainer = document.createElement("div");
        clusterLabelContainer.className = "label documentClusterMarkerCount";
        const clusterLabel = document.createElement("span");
        clusterLabel.textContent = documentCount;
        clusterLabelContainer.appendChild(clusterLabel);
        documentClusterMarker.content.appendChild(clusterLabelContainer);

        return documentClusterMarker;
    }

    static _createSvgClusterMarker(map, position) {
        const div = document.createElement('div');
        div.className = 'svgMarker svgMarker--cluster';
        div.innerHTML = svgClusterCircle;
        div.dataset.markerRenderer = 'svg';

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: new google.maps.LatLng(position.lat(), position.lng()),
            content: div,
            gmpClickable: true
        });

        return marker;
    }

    static createDocumentMarker(map, markerData){
        // 1–7 + 99 haben eigene Configs; jede unbekannte category_id fällt auf 'default' zurück.
        const svgConfig = svgMarkerConfig[markerData.categoryId] ?? svgMarkerConfig.default;

        const documentMarker = this._createSvgDocumentMarker(map, markerData, svgConfig);
        documentMarker.customId = markerData.id;
        return documentMarker;
    }

    static _createSvgDocumentMarker(map, markerData, svgConfig) {
        const rotation = markerData.rotation;
        const hasRotation = rotation != null && rotation !== 0 && rotation !== '';

        const svgString = svgConfig.full;
        const div = document.createElement('div');
        div.className = `svgMarker svgMarker--${svgConfig.class}`;
        div.innerHTML = svgString;
        div.dataset.markerRenderer = 'svg';
        div.dataset.rotation = rotation ?? 0;

        if(hasRotation) {
            const markerSegment = document.createElement('div');
            markerSegment.className = 'svgMarker svgMarker--segment';
            markerSegment.innerHTML = svgMarkerSegment;
            markerSegment.style.transform = `translate(-50%, -50%) rotate(${rotation-90}deg)`;
            div.appendChild(markerSegment);
        }

        const marker = new google.maps.marker.AdvancedMarkerElement({
           map,
           position: new google.maps.LatLng(markerData.lat, markerData.lng),
           content: div,
           gmpClickable: true
        });
        marker.customId = markerData.id;

        return marker;
    }

    static _setSvgRotatedState(marker) {
        const rotation = parseInt(marker.content.dataset.rotation || 0, 10);
        let heading = 0;
        try {
            if(marker.map !== null) { heading = marker.map.getHeading(); }
        } catch(e) {
            console.debug('[MarkerFactory] _setSvgRotatedState: getHeading() failed,', e);
        }
        const adjusted = (rotation - heading + 360) % 360;
        const segmentEl = marker.content.querySelector('.svgMarker--segment');
        if(segmentEl) { segmentEl.style.transform = `translate(-50%, -50%) rotate(${adjusted-90}deg)`; }
    }
}
